import React from 'react';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import './HelpCenter.css';

const HelpCenter = () => {
  return (
    <div className="help-center-page">
      <FrontHeader />
      <div className="help-center-container">
        <h1>Help Center</h1>
        <p className="subtitle">Find answers to common questions and get support</p>

        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-item">
            <h3>How do I post a job?</h3>
            <p>Log in to your owner account, go to "Post a Job", fill in vessel details, service requirements, budget, and deadline. Your job will be visible to verified service providers.</p>
          </div>

          <div className="faq-item">
            <h3>How does escrow payment work?</h3>
            <p>Ship owners deposit funds into a secure escrow account when a quotation is accepted. The funds are held safely and only released to the service provider after work is completed and approved by the owner.</p>
          </div>

          <div className="faq-item">
            <h3>How do I become a verified service provider?</h3>
            <p>Register as a service provider, complete your company profile, upload necessary certifications, and wait for admin verification. Once approved, you can start bidding on jobs.</p>
          </div>

          <div className="faq-item">
            <h3>What fees does SeaZex charge?</h3>
            <p>SeaZex charges a 10% platform fee on the total quotation amount from the service provider. There are no hidden fees for ship owners.</p>
          </div>

          <div className="faq-item">
            <h3>How long does payment release take?</h3>
            <p>After the owner approves work completion, funds are released instantly to the provider's wallet. Withdrawals are processed within 3-5 business days.</p>
          </div>
        </div>

        <div className="contact-support">
          <h2>Still need help?</h2>
          <p>Contact our support team:</p>
          <ul>
            <li><i className="fas fa-envelope"></i> support@seazex.com</li>
            <li><i className="fas fa-phone-alt"></i> +971 4 123 4567</li>
            <li><i className="fas fa-comments"></i> Live chat available 24/7</li>
          </ul>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default HelpCenter;